<script lang="ts">

import { templateRef } from '@vueuse/core'
import gsap from 'gsap'
import { defineComponent, onMounted, ref } from 'vue'

import AsyncIcon from '@/components/atoms/AsyncIcon.vue'

export default defineComponent({
  name: 'TheLoader',
  components: { AsyncIcon },
  setup () {
    const isLoading = ref(true)
    const loaderEl = templateRef<HTMLDivElement>('loaderEl')
    const logoEl = templateRef<HTMLElement>('logoEl')
    const tl = gsap.timeline({ onComplete: () => { isLoading.value = !isLoading.value } })

    const animateLoading = () => {
      tl.fromTo(logoEl.value,
        {
          opacity: 0
        },
        {
          opacity: 1,
          duration: 3,
          ease: 'power2.out'
        })
        .to(logoEl.value, {
          opacity: 0,
          duration: 1.5,
          ease: 'power2.out'
        })
        .to(loaderEl.value, {
          scaleY: 0,
          duration: 1.2,
          ease: 'power4.inOut'
        })
    }

    onMounted(() => {
      animateLoading()
    })

    return {
      isLoading
    }
  }
})
</script>

<template>
  <div v-if="isLoading" ref="loaderEl" class="loader fixed top-0 left-0 flex flex-col items-center justify-center w-full h-full bg-black transform">
    <div ref="logoEl">
      <AsyncIcon name="logo" class="h-20 w-auto" />
    </div>
  </div>
</template>

<style scoped lang="scss">
.loader {
  z-index: 20;
  transform-origin: top;
}
</style>
